export const theme = {
  colors: {
    primaryColor: 'rgba(34, 42, 54, 0.95)',
    secondaryColor: 'rgba(0, 0, 0, 1)',
    accentColor: 'rgba(103, 108, 219, 1)',

    primaryTextColor: 'rgba(255, 255, 255, 1)',
    secondaryTextColor: 'rgba(255, 255, 255, 0.5)'
 },
  media: {
    tablet: "screen and (max-width: 768px)",
    mobile: "screen and (max-width: 576px)",
    desktop: "screen and (min-width: 980px)",
  },
  animation: {
      transition: "0.2s ease-in-out"
  }
}
